import {AbstractControl, ValidationErrors} from '@angular/forms';
import {ThuisverzorgerDienst} from "../../thuisverzorger/thuisverzorger-dienst";

export class ZahValidators {

  static notBlank(control: AbstractControl): ValidationErrors | null {
    const isValid = (control.value || '').trim().length > 0;
    return isValid ? null : {notBlank: true};
  }

  // TODO rename
  static notInvalidDiensten(control: AbstractControl): ValidationErrors | null {
    const diensten: ThuisverzorgerDienst[] = control.value;

    if (diensten.length === 0) {
      return {notBlank: true};
    }

    if (diensten.some(dienst => !dienst.isValid())) {
      return {dienstInvalid: true};
    }

    return null;
  }
}
